
import HeartSearch from "../../../assets/outline/HeartSearch.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HeartSearchIcon({ className, dataTestid = "HeartSearchIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <HeartSearch data-testid={dataTestid} className={classes} {...rest} />
  );
}
